"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as e } from "react";
import t from "../components/Icon/SvgIcon.js";
const i = (l) => /* @__PURE__ */ o(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...l,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M22 3.238c-1.71-.476-3.654-.738-5.59-.738-6.897 0-13.165 4.19-14.253 9.425-1.062 5.117 3.356 9.092 10.067 9.092 1.53 0 4.757-.214 6.235-.713l1.642-6.712c-1.586 1.023-3.28 1.665-5.246 1.665-2.559 0-4.458-1.522-4.048-3.498.405-1.951 2.817-3.499 5.376-3.499 1.935 0 3.479.833 4.65 1.81z",
        clipRule: "evenodd"
      }
    )
  }
), m = e(i);
export {
  m as CostcoCFilled,
  m as default
};
